import { render, staticRenderFns } from "./TotalInventoryStatisticsCard.vue?vue&type=template&id=f0c7ec7e&scoped=true"
import script from "./TotalInventoryStatisticsCard.vue?vue&type=script&lang=js"
export * from "./TotalInventoryStatisticsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c7ec7e",
  null
  
)

export default component.exports